<phx-dialog
  [phxWidth]="modalWidth"
  [phxOpen]="phxOpen"
  (phxOpenChange)="phxOpenChange.emit($event)"
  (phxBackdropClicked)="onBackdropClicked()"
  (phxKeydown)="onKeydown($event)"
>
  <div class="phx-modal-confirm">
    <ng-content select="[phx-modal-header]"></ng-content>
    <ng-content select="[phx-modal-body]"></ng-content>
    <ng-content select="[phx-modal-footer]"></ng-content>
  </div>
</phx-dialog>
